import React from 'react'
import { generateMargin } from '../Spacing/Margin'
import { generatePadding } from '../Spacing/Padding'

const HeadingThree = ({ text, color, margin, padding, className, headingCSSStyles }) => {
  return (
    <React.Fragment>
        <h3 style={{color:color,...generatePadding(padding?.direction,padding?.number), ...generateMargin(margin?.direction,margin?.number), ...headingCSSStyles}} className={`text-[32px] font-bold font-DMSans ${className}`}>{text}</h3>
    </React.Fragment>
  )
}

export default HeadingThree